const { cELM } = require('../../utils');
const Chat = require('../../chat');
const sanitizer = require('../../utils/sanitizer');

class DoubleTextInput {
  constructor(data, validator, placeholder1, placeholder2) {
    this._data = data;
    this.type = 'text';
    this.validator = validator;
    this.elements = null;
    this.element = cELM('div', 'option-block');
    this.placeholder1 = placeholder1 || getLngTxt('input.placeholder.firstname');
    this.placeholder2 = placeholder2 || getLngTxt('input.placeholder.lastname');
  }

  getELM() {
    return this.element;
  }

  setAutoFocus(v) {
    this._autofocus = v;
  }

  getHTML() {
    const onChange = function (evt) {
      if (evt.key === 'Enter') {
        submitButton.click();
      }

      setTimeout(() => {
        const sanitizedInput1 = sanitizer.sanitizeString(input1.value);
        const sanitizedInput2 = sanitizer.sanitizeString(input2.value);
        if (sanitizedInput1.length > 0 && sanitizedInput2.length > 0) {
          submitButton.classList.add('go-button-active');
        } else {
          submitButton.classList.remove('go-button-active');
        }
      }, 10);
    };

    const onSubmit = function () {
      // Both fields need to be filled in order to activate the submit button
      if (!submitButton.classList.contains('go-button-active') || (input1.value || '').length === 0 || (input2.value || '').length === 0) {
        return;
      }

      if (!validValue(input1) || !validValue(input2)) return;

      const data = { userInput1: input1.value, userInput2: input2.value, id: _self._data.id, answerKey: _self._data.answerKey };

      Chat.default.send(data, null, _self.element);
    }

    const buildTextInput = function (id, placeholder) {
      const input = cELM('input', `text-input ${id}`);
      input.placeholder = placeholder;
      input.type = 'text';
      input.onkeyup = onChange;
      input.onchange = onChange;
      return input;
    }

    const validValue = function (input) {
      const str = sanitizer.sanitizeString(input.value);
      if (!str) return false;
      input.blur();
      input.classList.remove('invalid');
      if (_self.validator && !_self.validator(str)) {
        input.classList.add('invalid');
        input.focus();
        return false;
      }
      return true;
    }

    const _self = this;
    const input1 = buildTextInput('i1', this.placeholder1);
    const input2 = buildTextInput('i2', this.placeholder2);
    const submitButton = cELM('div', 'go-button', getLngTxt('button.submit'));
    submitButton.onclick = onSubmit;

    const inputContainer = cELM('div','inputs-wrapper');
    inputContainer.addELM(input1);
    inputContainer.addELM(input2);

    this.element.addELM(inputContainer);
    this.element.addELM(submitButton);
    this.elements = { input1, input2,  submitButton };

    return this.element;
  }

  reset() {
    this.element.firstChild.value = '';
    this.element.firstChild.focus();
  }

  focus() {
    this.elements.input1.click();
    this.elements.input1.focus();
  };
}

module.exports = DoubleTextInput;
